// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { env } from "process";

export const environment = {
   production: false,
   API_VERSION :1,

    //Development Env
  // EVENT_MANAGEMENT_API: "https://fidelity-eventmgmt-dev.azurewebsites.net/api/",
  
   //Testing Env
  //  EVENT_MANAGEMENT_API: "https://fidelity-eventmgmt-staging-testing.azurewebsites.net/api/",

   //Staging Env
    // EVENT_MANAGEMENT_API: "https://fidelity-eventmgmt-staging.azurewebsites.net/api/",

    //PreProd env
    // EVENT_MANAGEMENT_API: "https://zan-preprod-eventmgmt.azurewebsites.net/api/",
     
     //Prod env
    EVENT_MANAGEMENT_API: "https://transformer-eventsmgmt.fidelity-services.com/api/",

     

};

